var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2eafbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ac3bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.045,
    y1: 0.5,
    x2: 1.045,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aaca6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24a2b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.006,
    y1: 0.5,
    x2: 1.005,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.005,
    y1: 0.024,
    x2: 0.017,
    y2: 0.975,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c8b8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.005,
    y1: 0.024,
    x2: 0.017,
    y2: 0.974,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.941,
    y1: 0.115,
    x2: 0.073,
    y2: 0.92,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11832",
    "data-name": "Group 11832",
    transform: "translate(11730 3344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(-12043 -3429)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(313 85)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12808",
    "data-name": "Path 12808",
    d: "M17,0A17,17,0,1,1,0,17,17,17,0,0,1,17,0Z",
    transform: "translate(-11729 -3343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(-11718 -3336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M297.433,112.375c0,.027,0,.055,0,.082v-.081A0,0,0,0,1,297.433,112.375Z",
    transform: "translate(-297.136 -108.438)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M297.447,107.675a1.593,1.593,0,0,0-.016.22v-.2A.148.148,0,0,1,297.447,107.675Z",
    transform: "translate(-297.136 -104.549)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M312.5,142.6a1.756,1.756,0,0,1-.164.452,1.378,1.378,0,0,1-.1.161,1.479,1.479,0,0,1-.16.206,1.725,1.725,0,0,1-.4.324l-11.551,6.881a1.656,1.656,0,0,1-.855.24,1.718,1.718,0,0,1-1.34-.66v-.579a1.459,1.459,0,0,0,1.34.945,1.368,1.368,0,0,0,.712-.2l11.551-6.881a1.472,1.472,0,0,0,.4-.352,1.434,1.434,0,0,0,.209-.369,1.191,1.191,0,0,0,.055-.165.667.667,0,0,1,.16-.395,1.8,1.8,0,0,0,.135-.393A1.883,1.883,0,0,1,312.5,142.6Z",
    transform: "translate(-297.538 -132.551)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M297.431,112.377v.081c0-.027,0-.055,0-.082A0,0,0,0,0,297.431,112.377Z",
    transform: "translate(-297.136 -108.438)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M312.483,146.66a1.765,1.765,0,0,1-.348.691,1.712,1.712,0,0,1-.457.393l-11.551,6.881a1.656,1.656,0,0,1-.855.24,1.715,1.715,0,0,1-1.321-.636,1.376,1.376,0,0,1-.019-.238v-.365a1.459,1.459,0,0,0,1.34.945,1.368,1.368,0,0,0,.712-.2l11.551-6.881a1.462,1.462,0,0,0,.7-1.061,1.373,1.373,0,0,0,.1-.161,1.756,1.756,0,0,0,.164-.452A1.888,1.888,0,0,1,312.483,146.66Z",
    transform: "translate(-297.538 -135.766)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M297.431,112.377v.081c0-.027,0-.055,0-.082A0,0,0,0,0,297.431,112.377Z",
    transform: "translate(-297.136 -108.438)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M310.876,102.9a1.7,1.7,0,0,1-.349.672,1.318,1.318,0,0,1-.648.928L298.319,111.2a1.315,1.315,0,0,1-.665.181,1.352,1.352,0,0,1-1.322-1.114,1.308,1.308,0,0,1-.019-.231v-2.084a1.716,1.716,0,0,0,2.2.409l11.019-6.377.383-.222.158-.092a1.835,1.835,0,0,0,.219-.149,1.579,1.579,0,0,0,.208-.2.715.715,0,0,0,.071-.084.63.63,0,0,0,.061-.084,1.284,1.284,0,0,0,.126-.214,1.724,1.724,0,0,0-.684-2.256l-11.561-6.689a1.718,1.718,0,0,0-2.578,1.492v16.548a1.723,1.723,0,0,0,1.723,1.727,1.7,1.7,0,0,0,.856-.233l11.561-6.691A1.722,1.722,0,0,0,310.876,102.9Z",
    transform: "translate(-295.931 -91.759)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M312.5,138.6a1.8,1.8,0,0,1-.135.393,1.327,1.327,0,0,1-.126.22.642.642,0,0,1-.061.086,1.729,1.729,0,0,1-.122.145,1.7,1.7,0,0,1-.3.249c-.025.018-.049.033-.076.049l-11.551,6.881a1.656,1.656,0,0,1-.855.24,1.718,1.718,0,0,1-1.34-.66v-.579a1.459,1.459,0,0,0,1.34.945,1.368,1.368,0,0,0,.712-.2L311.51,139.5l.025-.016a1.435,1.435,0,0,0,.3-.236,1.343,1.343,0,0,0,.2-.257,1.387,1.387,0,0,0,.141-.306c.01-.027.019-.057.027-.086a.667.667,0,0,1,.16-.395,1.8,1.8,0,0,0,.135-.393A1.883,1.883,0,0,1,312.5,138.6Z",
    transform: "translate(-297.538 -129.337)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 0.524,
    height: 14.608,
    rx: 0.262,
    transform: "translate(2.288 1.513)",
    fill: "#eaecf0",
    opacity: 0.19
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.b18e0c1827fbe8ba246a14709d31071b.svg";
export { ForwardRef as ReactComponent };